import { render, staticRenderFns } from "./ChannelPill.vue?vue&type=template&id=db02cefa&scoped=true"
import script from "./ChannelPill.vue?vue&type=script&lang=js"
export * from "./ChannelPill.vue?vue&type=script&lang=js"
import style0 from "./ChannelPill.vue?vue&type=style&index=0&id=db02cefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db02cefa",
  null
  
)

export default component.exports